import { render, staticRenderFns } from "./RequirementSimulationTable.vue?vue&type=template&id=676aa4b8&scoped=true&"
import script from "./RequirementSimulationTable.vue?vue&type=script&lang=js&"
export * from "./RequirementSimulationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676aa4b8",
  null
  
)

export default component.exports